import styled from 'styled-components';

import { grey10, grey2, grey5 } from 'approot/shared/styles/colours.style';
import { rem } from 'approot/shared/style';
import {
  spacing12,
  spacing16,
  spacing4,
} from 'approot/shared/styles/spacing.style';
import {
  baseBoxShadowFocus,
  borderRadius8,
} from 'approot/shared/styles/borders.style';
import { fontSize16LineHeight } from 'approot/shared/styles/typography.style';
import { SecondaryBaseStyled } from 'approot/shared/styles/buttons/secondary-button.style';
import { flexSpaceBetweenCss } from 'approot/shared/styles/flex.style';

export const SortableItem = styled.div`
  border: 1px solid ${grey5};
  border-radius: ${rem(borderRadius8)};
  overflow: hidden;
  margin-bottom: ${rem(spacing16)};
`;

export const SortableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${rem(spacing4)};
  background-color: ${grey2};
  border-bottom: 1px solid ${grey5};
`;

export const SortableContent = styled.div`
  padding: ${rem(spacing12)};
`;

export const SortableContentButton = styled.button`
  ${SecondaryBaseStyled}
  ${flexSpaceBetweenCss}

  &:focus {
    box-shadow: inset ${baseBoxShadowFocus};
  }

  border-radius: 0 0 ${rem(borderRadius8)} ${rem(borderRadius8)};
  border: none;
  line-height: ${rem(fontSize16LineHeight)};
  margin: 0;
  height: auto;
  padding: ${rem(spacing12)};
  text-align: left;
  width: 100%;

  & > div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  }

  & > svg {
    flex-shrink: 0;
    fill: ${grey10};
    stroke: none;
    transform: rotate(-90deg);
  }
`;
